import { useEffect } from 'react';

/** s
  * @description Subscribes to key and mouse hit down to change :focus styling
  *
 */
const useKeyboardFocusOnly = () => {

    const mouseDownHandler = () => {

        document.body.classList.add('using-mouse');

    };

    const keyDownHandler = () => {

        document.body.classList.remove('using-mouse');

    };
    
    useEffect(() => {

        document.addEventListener('mousedown', mouseDownHandler);
        document.addEventListener('keydown', keyDownHandler);

        return () => {

            document.removeEventListener('mousedown', mouseDownHandler);
            document.removeEventListener('keydown', keyDownHandler);

        };

    }, []);

};

export default useKeyboardFocusOnly;
